export const BASELINE_THRESHOLD_DAYS = 20;

export const DAY = 24 * 60 * 60 * 1000;
export const YEAR = 365.25 * DAY;
export const MONTH = DAY * 30; // Generic 30-day month approximation; not accurate for a specific calendar month.

export const STATUS_COLORS = {
    'To Do': '#5A6DEE',
    'In Progress': '#142980',
    Done: '#63A450',
};

export const COMPARISON_COLORS = {
    baseline: '#B8BDC2',
    forecast: '#FF5610',
};

export const UI = {
    DIAMOND_PX: 22,
    LABEL_BOX_W: 250,
    LABEL_GAP_PX: -8,
    LEFT_LABEL_EXTRA: 30,
    SAFE_PAD: -100,
};

export const DERIVED_CONSTANTS = {
    BAR_LABEL_RESERVE_PX: Math.max(0, UI.LABEL_GAP_PX + UI.LABEL_BOX_W + UI.SAFE_PAD),
    BASE_MILESTONE_LABEL_HALF: Math.max(
        Math.round(UI.DIAMOND_PX / 2),
        Math.round(UI.DIAMOND_PX / 2 + UI.LABEL_GAP_PX + UI.LABEL_BOX_W + UI.LEFT_LABEL_EXTRA + UI.SAFE_PAD),
    ),
};
